import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/masterdata-api/valuelist/page', params)

// 删除
export const removeItem = id =>
  request.get(`/masterdata-api/valuelist/delete/${id}`)

// 新增或更新菜单
export const updateOrAdd = params =>
  request.post('/masterdata-api/valuelist/add', params)

// 获取查询列表数据
export const getOptionList = () =>
  request.get('/masterdata-api/valuelist/ValueType/list')
